import { useState } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useAppContext } from 'contexts/AppContext';
import { sendContactForm } from 'api';
import Nav from '@/components/modules/Nav/Nav';
import Button from '@/components/elements/Button/Button';
import Input from '@/components/elements/Input/Input';
import HintMessage from '@/components/elements/HintMessage/HintMessage';
import styles from '../styles/ContactUs.module.scss';

const ContactUs = () => {
    return ( 
        <>
        <div className={styles.contactUs}>
            <section className={styles.headerSection}>
                <div className={styles.titleSection}>
                    <h1>Contact Us</h1>
                    <div className={styles.titleSection__divider}></div>
                </div>
                <div className={styles.description}>The quickest way to reach us is through the chat</div>
                <Button theme="blue" onClick={()=>{window?.Intercom('showNewMessage')}}>Chat with us</Button>
            </section>
            <div className={styles.linesDivider}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <section className={styles.formSection}>
                <div className={styles.description}>
                    If you perfer email, you can fill out the form below and we’ll get back to you as soon as possible.
                </div>
                <ContactForm />
                <div className={styles.footer}>
                    <div>afterglow</div>
                    <div itemScope itemType="https://schema.org/Person">
                        <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                            <span itemProp="streetAddress">13809 Research Blvd Suit 500 PMB 93866 </span>
                            <span itemProp="addressLocality">Austin</span>,
                            <span itemProp="addressRegion"> TX </span>
                            <span itemProp="postalCode">78729</span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        </>
     );
}

const ContactForm = () => {

    const { setAppLoading, appLoading } = useAppContext();
    const [formData, setFormData] = useState({firstName: "", lastName: "", email: "", message: ""})
    const [hint, setHint] = useState({type: "", message: ""})

    async function handleSubmit(){
        setAppLoading(true)
        try{
            const res = await sendContactForm(formData)
            if(res.data.status === "success"){
                setHint({type: "success", message: "Message received! We will get back to you shortly."})
                clearFormData()
            }else{
                setHint({type: "error", message: <>Something went wrong. Please reach out to <a href="mailto:shout@xoafterglow.com">shout@xoafterglow.com</a>.</>})
            }
        }catch(e){
            console.log('error: ', e)
            Sentry.captureException(e)
        }
        setAppLoading(false)
    }

    function canSubmit(){
        for(let field of Object.keys(formData)){
            if(formData[field] === ""){
                return false
            }
        }
        return true && !appLoading
    }

    function clearFormData(){
        let formDataCopy = {...formData}
        for(let key of Object.keys(formDataCopy)){
            formDataCopy[key] = ""
        }
        setFormData(formDataCopy)
    }

    return (
    <form className={styles.form} onSubmit={(e)=>{e.preventDefault(), handleSubmit()}}>
        <div>
            <Input type="text" placeholder="First name" value={formData.firstName} onChange={(value)=>setFormData({...formData, firstName: value})}/>
            <Input type="text" placeholder="Last name" value={formData.lastName} onChange={(value)=>setFormData({...formData, lastName: value})}/>
        </div>
        <div>
            <Input type="email" placeholder="Email" value={formData.email} onChange={(value)=>setFormData({...formData, email: value})}/>
        </div>
        <div>
            <Input as="textarea" placeholder="Your message" value={formData.message} onChange={(value)=>setFormData({...formData, message: value})}/>
        </div>
        <Button theme="blue" type="submit" active={canSubmit()}>Submit</Button>
        <div className={styles.form__hint}>
            <HintMessage type={hint.type} show={hint.message!==""}>{hint.message}</HintMessage>
        </div>
    </form>
    )
}
ContactUs.Nav = <Nav dark={true} />
export default ContactUs;

